import { z } from 'zod'
import { EVENT_NAMES } from '../../services/Analytics/Analytics'
import type { WarningConfig } from '../../types/warning.types'

export const PhotoBookWarningTypeSchema = z.enum([
  'lowres',
  'not-enough-photos',
])

export type PhotoBookWarningType = z.infer<typeof PhotoBookWarningTypeSchema>

export const photoBookWarningConfig: WarningConfig<PhotoBookWarningType> = {
  lowres: {
    t: {
      label: 'photo_book.low_res_photos.cart_label',
      cta: 'photo_book.low_res_photos.cart_cta',
    },
    analytics: {
      displayed: EVENT_NAMES.BOOKS_LOW_RES_WARNING_DISPLAYED,
      tapped: EVENT_NAMES.BOOKS_LOW_RES_WARNING_TAPPED,
      dismissed: EVENT_NAMES.BOOKS_WARNING_DISMISSED,
    },
  },
  'not-enough-photos': {
    t: {
      label: 'photo_book.not_enough_photos.cart_label',
      cta: 'photo_book.not_enough_photos.cart_cta',
    },
    analytics: {
      displayed: EVENT_NAMES.BOOKS_NOT_ENOUGH_PHOTOS_WARNING_DISPLAYED,
      tapped: EVENT_NAMES.BOOKS_NOT_ENOUGH_PHOTOS_WARNING_TAPPED,
      dismissed: EVENT_NAMES.BOOKS_WARNING_DISMISSED,
    },
  },
}
